<!-- events -->
<div class="section section-events container-fluid">

  <a class="section-anchor" name="section-events"></a>

  <div class="row align-content-stretch">

    <div class="col-12 col-sm-4 col-xl-6 column-left flex-fill align-self-center">

      <div class="d-flex flex-column align-items-center justify-content-center">

        <h3 class="alternate-heading align-self-stretch justify-content-center d-flex text-center mb-3">
          {{'Events' | translate}}
        </h3>

        <a routerLink="/events" class="btn btn-light btn-white btn-special btn-sm">
          {{ 'View all events' | translate}}
        </a>

      </div>

    </div>

    <div class="col-12 col-sm-8 col-xl-6 column-right align-items-stretch">

      <div class="jumbotron jumbotron-events d-flex align-self-center">

        <div class="slider-events">

          <!-- desktop view -->
          <span class="d-none d-lg-block">
            <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="eventSlider.slides_desktop">
              <ng-template *ngFor="let slide of eventSlider.slides_desktop" ngbSlide>

                <div class="row">
                  <div class="col-12" *ngFor="let slideItem of slide">
                    <a class="event-link" [routerLink]="'events/' + slideItem.id">
                      <div class="event-caption">
                        <h3 class="event-date" *ngIf="slideItem.eventDate || slideItem.eventPeriodDescription">{{(slideItem.eventPeriodDescription ? slideItem.eventPeriodDescription : slideItem.eventDate | date : "dd-MM-YYYY")}}</h3>
                        <h3 class="event-title" *ngIf="externalpageService.getTranslatedTitle(slideItem)">{{externalpageService.getTranslatedTitle(slideItem) }}</h3>
                        <div class="event-content" *ngIf="externalpageService.getTranslatedContent(slideItem)">
                          <span [innerHTML]="externalpageService.getTranslatedContent(slideItem) | striphtml"></span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </span>

          <!-- mobile view -->
          <span class="d-block d-lg-none">
            <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="false" *ngIf="eventSlider.slides_mobile">
              <ng-template *ngFor="let slide of eventSlider.slides_mobile" ngbSlide>

                <div class="row">
                  <div class="col-12" *ngFor="let slideItem of slide">
                    <a class="event-link" [routerLink]="'events/' + slideItem.id">
                      <div class="event-caption">
                        <h3 class="event-date" *ngIf="slideItem.eventDate || slideItem.eventPeriodDescription">{{(slideItem.eventPeriodDescription ? slideItem.eventPeriodDescription : slideItem.eventDate | date : "dd-MM-YYYY")}}</h3>
                        <h3 class="event-title" *ngIf="slideItem.title">{{externalpageService.getTranslatedTitle(slideItem) }}</h3>
                        <div class="event-content" *ngIf="externalpageService.getTranslatedContent(slideItem)">
                          <span [innerHTML]="externalpageService.getTranslatedContent(slideItem) | striphtml"></span>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </span>

        </div>

      </div>

    </div>

  </div>

</div>
